import { render } from "./CreateVariationModal.vue?vue&type=template&id=33d9faf7"
import script from "./CreateVariationModal.vue?vue&type=script&lang=js"
export * from "./CreateVariationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__